// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';
import { ro } from 'date-fns/locale';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
  CAMERA: '/camera',
};

// ----------------------------------------------------------------------

export const paths = {
  profile: `/home/profile`,
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  blog: {
    root: `/blog`,
    details: (slug: string) => `/blog/${slug}`,
  },

  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  camera:{
    root: `${ROOTS.CAMERA}/camera-toan-canh`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    blank: `${ROOTS.DASHBOARD}/blank`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,

    articletype: {
      root: `${ROOTS.DASHBOARD}/articletype`, 
      details: (id: number) => `${ROOTS.DASHBOARD}/articletype/${id}`,
      new: `${ROOTS.DASHBOARD}/articletype/new`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/articletype/${id}/edit`,
    },
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    menu: {
      root: `${ROOTS.DASHBOARD}/menu`,
      list: `${ROOTS.DASHBOARD}/menu`,
      new: `${ROOTS.DASHBOARD}/menu/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/menu/${id}/edit`,
      details: (id: string) => `${ROOTS.DASHBOARD}/menu/${id}`,
    },
    hethong: {
      root: `${ROOTS.DASHBOARD}/hethong`,
      listPhanQuyenTaiKhoan: `${ROOTS.DASHBOARD}/hethong/list-phan-quyen-tai-khoan`,
      refreshToken: `${ROOTS.DASHBOARD}/hethong/refresh-token`,
    },
    vuontrong:{
      root: `${ROOTS.DASHBOARD}/vuontrong`,
      list: `${ROOTS.DASHBOARD}/vuontrong/list`,
      new: `${ROOTS.DASHBOARD}/vuontrong/new`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/vuontrong/${id}/edit`,
    },
    losam: {  
      root: `${ROOTS.DASHBOARD}/losam/list`,
      list: `${ROOTS.DASHBOARD}/losam/list`,
      tracuu: `${ROOTS.DASHBOARD}/losam/tracuu`,
      new: `${ROOTS.DASHBOARD}/losam/new`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/losam/${id}/edit`,
    },
    vaitro:{ 
      root: `${ROOTS.DASHBOARD}/vaitro`,
      new: `${ROOTS.DASHBOARD}/vaitro/new`, 
      list: `${ROOTS.DASHBOARD}/vaitro/list`,  
      edit: (id: string) => `${ROOTS.DASHBOARD}/vaitro/${id}/edit`,
      details: (id: string) => `${ROOTS.DASHBOARD}/vaitro/${id}`,
      
    },
    account:{
      root : `${ROOTS.DASHBOARD}/taikhoan`,
      list: `${ROOTS.DASHBOARD}/account/list`,  
      edit: (id: string) => `${ROOTS.DASHBOARD}/account/${id}/edit`,
      new: `${ROOTS.DASHBOARD}/account/new`, 
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    }, 
    blog: {
      root: `${ROOTS.DASHBOARD}/blog`,
      new: `${ROOTS.DASHBOARD}/blog/new`,
      details: (id: number) => `${ROOTS.DASHBOARD}/blog/${id}`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/blog/${id}/edit`,
      demo: { 
        details: `${ROOTS.DASHBOARD}/blog/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/blog/${MOCK_ID}/edit`,
      },
    },
   
   
  },
   caysam:{
      root:(id:number) =>`${ROOTS.DASHBOARD}/caysam/${id}`
    }
};
